export const isAdminFromUser = (user) => {
  const appMeta = user?.app_metadata || user?.raw_app_meta_data || {};
  const role =
    typeof appMeta?.role === 'string'
      ? appMeta.role.trim().toLowerCase()
      : '';
  const roles = Array.isArray(appMeta?.roles)
    ? appMeta.roles
        .map((value) => (typeof value === 'string' ? value.trim().toLowerCase() : null))
        .filter(Boolean)
    : [];

  return role === 'admin' || roles.includes('admin');
};

